import { Component, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Product, ProductSpecification } from 'src/@omnial/_models/catalog/product.model';
import { CartService } from 'src/@omnial/_services/order/cart.service';

@Component({
    selector: 'app-controls-list',
    templateUrl: './../../../app/product-controls/controls-list/controls-list.component.html',
    standalone: false
})
export class ControlsListComponent {
  @Input() productSimple: Product;
  @Input() listName: string;
  @Input() listId: string;
  @Output() onOpenProductDialog: EventEmitter<Product> = new EventEmitter();

  public cartForm = new FormGroup({ quantity: new FormControl(1, Validators.compose([Validators.required]))});

  constructor(
    public router: Router,
    public cartService: CartService,
    public toastr: ToastrService) { }

  public addToWishList(product: Product): void {
    product.listName = this.listName ?? "Product List";
    product.listId = this.listId;
    this.cartService.addToWishlist(product);
  }

  public addToCart(product: Product): void {
    let qty = 1;
    if (this.cartForm?.controls?.quantity?.value) {
      qty = this.cartForm?.controls?.quantity?.value;
    }
    product.listName = this.listName ?? "Product List";
    product.listId = this.listId;
    this.cartService.addToCart(product, qty);
  }

  public outOfStock(product: Product): void {
    const message = `Sorry ${product.name} is temporarily out of stock. Go to the product page or tap this message to find out more.`;
    const toastrCart = this.toastr.success(message, 'Out of Stock');
    toastrCart.onTap.subscribe(() => this.router.navigate(['/products/' + product.seName]));
  }

  public openProductDialog(event: Product): void {
    this.onOpenProductDialog.emit(event);
  }

  public specification(name: string): ProductSpecification {
    if (this.productSimple?.specifications) {
      return this.productSimple.specifications.find(s => s.specificationAttributeName === name);
    }
    return null;
  }
}
